import React from 'react';
import qs from 'qs';
import { Modal } from '../Modal';
import { useMatchesMinWidth } from '../../../hooks/useMatchesMinWidth';
import { BREAKPOINTS } from '../../../../constants';
import { TRANSLATIONS } from '../../../../translations';
import Button, { ButtonSizes, ButtonStyles } from '../../Button/Button';
import Drawer from '../../../ui-components/Drawer/Drawer';
import Typography, {
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import BetaIcon, { IconColors, IconSizes } from '../../Icons/Icon';
import BetaAccordion from '../../Accordion/Accordion';
import AllFiltersSelectedFilter from '../../FilterResults/components/AllFiltersSelectedFilter';
const ModalFilters = (props) => {
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );

  const {
    location,
    history,
    isResetDisabled,
    filteredListings,
    onClickResetBtn,
    isBoatTrip,
    openModal,
    setOpenModal,
    filterComponents,
    openAccordionIndex,
    setOpenAccordionIndex,
    dateSpanString,
  } = props;

  const params = {
    ...{ isAlways: 'false', isNextMonth: 'false' },
    ...qs.parse(location.search, { ignoreQueryPrefix: true }),
  };

  const filtersKeys = filterComponents.map((filter) => filter.props.filterKey);
  const filterContents = filterComponents.reduce((acc, filter) => {
    acc[filter.props.filterKey] = filter.props.contents;
    return acc;
  }, {});

  const wrappedContent = (
    <>
      {
        <BetaAccordion
          classNames={'single-line'}
          label={TRANSLATIONS.ACTIVE_FILTERS}
          leftIcon={
            <BetaIcon
              name={'filters'}
              color={IconColors.regular}
              size={IconSizes[16]}
            />
          }
          isInitiallyOpen={true}
        >
          <AllFiltersSelectedFilter
            history={history}
            params={params}
            filtersKeys={filtersKeys}
            resetFilters={() => onClickResetBtn()}
            isInitiallyOpen={true}
            filterContents={filterContents}
            dateSpanString={dateSpanString}
          />
        </BetaAccordion>
      }
      {React.Children.map(filterComponents, (child, index) => {
        const isOpen =
          openAccordionIndex !== null && openAccordionIndex !== undefined
            ? openAccordionIndex === index
            : child.props.isInitiallyOpen;

        return (
          <BetaAccordion
            index={index}
            isInitiallyOpen={isOpen}
            label={child.props.label}
            classNames={
              child.props.contents && child.props.contents[0]?.subContents
                ? 'multi-line'
                : 'single-line'
            }
          >
            {child}
          </BetaAccordion>
        );
      })}
    </>
  );

  const footer = (
    <div className="filter-modal__footer">
      <Button
        size={ButtonSizes.s}
        style={ButtonStyles.empty}
        label={TRANSLATIONS.REMOVE_FILTERS}
        onClick={() => onClickResetBtn()}
        disabled={isResetDisabled}
      />
      <Button
        size={ButtonSizes.s}
        style={ButtonStyles.secondary}
        label={`${TRANSLATIONS.DISPLAY} ${filteredListings.length} ${TRANSLATIONS.ACTIVITIES}`}
        onClick={() => setOpenModal(false)}
      />
    </div>
  );

  const drawer = (
    <Drawer
      isOpen={openModal}
      onClose={() => setOpenModal(false)}
      title={
        <Typography variant="p2" weight={TypographyWeights['semi-bold']}>
          {TRANSLATIONS.ALL_FILTERS}
        </Typography>
      }
      body={<div className="filter-container-beta">{wrappedContent}</div>}
      footer={footer}
    />
  );

  const modal = (
    <Modal
      onClickOverlay={() => setOpenModal(false)}
      isOpen={openModal}
      shouldScroll={false}
    >
      <div className="filter-modal p-none">
        <div className="filter-modal__header">
          <div className="w-100% pt-xs pl-xs pr-xs d-flex justify-end">
            <button onClick={() => setOpenModal(false)}>
              <BetaIcon
                name={'close'}
                size={IconSizes[16]}
                color={IconColors.regular}
              />
            </button>
          </div>
          <div className="pl-s pr-s pb-2xs">
            <Typography variant="p2" weight={TypographyWeights['semi-bold']}>
              {TRANSLATIONS.ALL_FILTERS}
            </Typography>
          </div>
        </div>
        {
          <div className="filter-container-beta h-80vh">
            <div className="filter-container-beta__scrollbox">
              {wrappedContent}
            </div>
          </div>
        }
        {footer}
      </div>
    </Modal>
  );

  return (
    <React.Fragment>
      {isDeviceSmallerThanMblLandscape ? drawer : modal}
    </React.Fragment>
  );
};

export { ModalFilters };

export default ModalFilters;
